'use client';
import React from 'react';
import NextImage from '@/features/Image';
import { useAuth } from '../../hooks/auth';

interface LoginSocialProps {
  src: string;
  alt: string;
  url: string;
}

const LoginSocial: React.FC<LoginSocialProps> = ({ src, alt, url }) => {
  const { user } = useAuth({
    middleware: 'guest',
    redirectIfAuthenticated: 'goBack',
  });

  const handleClick = () => {
    const baseUrl = process.env.NEXT_PUBLIC_BACKEND_URL;
    window.location.href = baseUrl + url;
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        className="trk-btn trk-btn trk-btn--outline2 w-100 mt-3 d-flex align-items-center justify-content-center gap-2"
      >
        <NextImage width={24} height={24} src={src} alt={alt} />
        Login with {alt}
      </button>
    </>
  );
};

export default LoginSocial;
